/*! Unify Shopify v3.1.0 | (c) Unify <tech@unify.to> */
window.$uniExtraParams = {};

var uniSelectors = [
    "input[name='checkout']",
    "button[name='checkout']",
    '#buy-it-now-btn'
];
var xhttp = null;

(function() {
    disabledSelectors();
    setUnifyAffiliateParams();
    checkRequestEmptyCart();

    if(document.querySelector(uniSelectors[0])) {
        document.querySelectorAll(uniSelectors[0]).forEach(item => {
            item.addEventListener('click', function(event) {
                event.preventDefault ? event.preventDefault() : (event.returnValue = false);
                getCart();
            });
        });
    }
    
    if(document.querySelector(uniSelectors[1])) {
        document.querySelectorAll(uniSelectors[1]).forEach(item => {
            item.addEventListener('click', function(event) {
                event.preventDefault ? event.preventDefault() : (event.returnValue = false);
                getCart();
            });
        });
    }

    if(document.querySelector(uniSelectors[2])) {
        document.querySelector(uniSelectors[2]).addEventListener('click', function(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            event.stopPropagation();

            xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (this.readyState == 4 && this.status == 200) {
                    var xhttp2 = new XMLHttpRequest();
                    xhttp2.onreadystatechange = function() {
                        if (this.readyState == 4 && this.status == 200) {
                            getCart();
                        }
                    };
                    xhttp2.open('POST', '/cart/add.js', true);
                    xhttp2.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
                    xhttp2.send(JSON.stringify(serializeFormArray(document.querySelector('form[action="/cart/add"]'))));
                }
            };
            xhttp.open('POST', '/cart/clear.js', true);
            xhttp.send();
        });
    }
})();

function getCart() {
    xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
            prepareAndSending(JSON.parse(this.responseText));
        }
    };
    xhttp.open('GET', '/cart.json', true);
    xhttp.send();
}

function emptyCart() {
    xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
            if (getCookie('discount_code')) {
                document.cookie = 'discount_code=; Max-Age=0'
            }
        }
    };
    xhttp.open('POST', '/cart.json', true);
    xhttp.send();
}

function checkRequestEmptyCart() {
    if (urlParam('empty-cart') == 'yes') {
        emptyCart();
    }
}

function disabledSelectors() {
    for(i in uniSelectors) {
        if(document.querySelector(uniSelectors[i])) {
            document.querySelector(uniSelectors[i]).removeAttribute('disabled');
        }
    }
}

function urlParam(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return null;
    } else {
        return decodeURI(results[1]) || 0;
    }
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function prepareAndSending(unifyCartData) {
    var base_url = Shopify.shop;
    var url = base_url.replace(/^https?:\/\//, '');
    var parts = url.split('.');
    var sub_domain = parts[0];
    var autoFillPromo = '',
        newData = JSON.stringify(unifyCartData);
    if (url.search('myshopify') == -1) {
        url = sub_domain + '.myshopify.com';
    }
    var action = 'https://platform.unify.to/checkout/';
    var current_url = window.location.origin.replace(/^https?:\/\//, '');
    if (typeof unifyWhitelistedCheckoutDomain != 'undefined') {
        action = 'https://' + unifyWhitelistedCheckoutDomain + '/checkout';
    }
    if (urlParam('debug') == 'yes') {
        action = 'https://platform.unify.local/checkout';
    }
    if (urlParam('version') !== null) {
        action = 'https://' + urlParam('version') + '-dot-unify-app-cc.appspot.com/checkout';
    }
    if (sessionStorage.getItem('unify_affiliate_params')) {
        action += ('?' + sessionStorage.getItem('unify_affiliate_params'));
    }
  	if (sessionStorage.getItem('unify_referral_code')) {
      if (sessionStorage.getItem('unify_affiliate_params')) {
        action += ('&referred_id=' + sessionStorage.getItem('unify_referral_code'));
      }
      else {
        action += ('?referred_id=' + sessionStorage.getItem('unify_referral_code'));
      } 
    }
  
    if (getCookie('discount_code')) {
        autoFillPromo = '<input type="hidden" name="uni_autofill_promo" value="' + getCookie('discount_code') + '" >';
    }
    var checkoutForm = '<form name="unify_external_checkout_form" method="POST" action="' + action + '"><input type="hidden" name="cart_data" value="' + encodeURI(newData) + '" ><input type="hidden" name="slug" value="' + sub_domain + '" ><input type="hidden" name="base_url" value="' + url + '" ><input type="hidden" name="redirection" value="' + current_url + '" >' + autoFillPromo + '</form>';
    document.querySelector('body').insertAdjacentHTML('beforeend', checkoutForm);
    sessionStorage.removeItem('unify_affiliate_params');

    /**
     * Added extra params in the from
     */
    for(paramKey in window.$uniExtraParams) {
        document.querySelector('[name=unify_external_checkout_form]').insertAdjacentHTML('beforeend', '<input type="hidden" name="uni_checkout_extra_params[' + paramKey + ']" value="' + window.$uniExtraParams[paramKey] + '" >');
    }

    /**
     * Before checkout form submit action
     */
    if(typeof window['uniBeforeCheckoutFromSubmit'] === 'function') {
        uniBeforeCheckoutFromSubmit(function() {
            document.querySelector('[name=unify_external_checkout_form]').submit();
        });
    } else {
        document.querySelector('[name=unify_external_checkout_form]').submit();
    }
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function serializeFormArray (form) {
    var serialized = {};
    for (var i = 0; i < form.elements.length; i++) {
        var field = form.elements[i];
        if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;
        if (field.type === 'select-multiple') {
            for (var n = 0; n < field.options.length; n++) {
                if (!field.options[n].selected) continue;
                serialized[field.name] = field.options[n].value;
            }
        }
        else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
            serialized[field.name] = field.value;
        }
    }
  return serialized;
}

function setUnifyAffiliateParams() {
  
    var params = [];
    var tokens = [
        'AFID',
        'SID',
        'AFFID',
        'affId',
        'C1',
        'C2',
        'C3',
        'AID',
        'OPT',
        'click_id',
        'test_config_id',
         /**
         * GA Tokens
         */
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'utm_term',
        'device_category'
    ];

    for (var i = 0; i < tokens.length; i++) {
        if (urlParam(tokens[i])) {
            params.push(tokens[i] + '=' + urlParam(tokens[i]))
        }

        if (urlParam(tokens[i].toLowerCase()) && !params.includes(tokens[i].toLowerCase() + '=' + urlParam(tokens[i].toLowerCase()))) {
            params.push(tokens[i].toLowerCase() + '=' + urlParam(tokens[i].toLowerCase()))
        }
    }
  	
  	if (urlParam('smile_referral_code')) {
          sessionStorage.setItem('unify_referral_code', urlParam('smile_referral_code'));
   	}
  	
  	if (urlParam('aic')) {
          sessionStorage.setItem('unify_referral_code', urlParam('aic'));
   	}
	
    if (params && !sessionStorage.getItem('unify_affiliate_params')) {
      	
        sessionStorage.setItem('unify_affiliate_params', params.join('&'));
    }

}

/**
 * Set extra params to Unify checkout form
 */
window.addUniExtraParam = function(key, value) {
    window.uniExtraParams[key] = value;
}